import { useEffect } from "react";
import { useAssistantViewRegistry } from "./viewContextStore";

export default function useAssistantViewContext(descriptor) {
  const registry = useAssistantViewRegistry();

  useEffect(() => {
    if (!registry) return undefined;

    registry.setRegisteredViewContext(descriptor || null);

    return () => {
      registry.clearRegisteredViewContext();
    };
  }, [descriptor, registry]);
}
